
<a *ngIf="this.isActivate && !this.isActivateFirstScene" class="btn-unika" (click)="changeDirection('currentScene')" href="javascript:;" >{{ 'BEFORE-SITUATION' | translate }} </a>
<a *ngIf="this.isActivateFirstScene" class="btn-unika" (click)="changeDirection('firstScene')" href="javascript:;" >{{ 'FUTURE-SITUATION' | translate }}</a>
